import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children, admin = false }) {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  if (!token) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (admin && role !== 'ADMIN') return <Navigate to="/" replace />;
  return children;
}
